const Images = {
  logo: require("./logo.webp"),
  logo2: require("./logo-2.webp"),
  faceScan: require("./face-scan.webp"),
  mobileFrame: require("./mobile-frame.webp"),
  pharmacist: require("./pharmacist.webp"),
  medKit: require("./med-kit.webp"),
  shopping: require("./shopping.webp"),
  capsules: require("./capsules.webp"),
  health: require("./health.webp"),
  downloadApp: require("./download-app.webp"),
  nicFront: require("./nic-front.webp"),
  nicBack: require("./nic-back.webp"),
  prescription: require("./upload-prescription.webp"),
  noti: require("./noti.webp"),
  cancelled: require("./cancelled.webp"),
  quoted: require("./quoted.webp"),
  insuranceCard: require("./insuranceCard.webp"),
  about: require("./about.webp"),
  notFound404: require("./page-not-found.webp"),
  Prescription1: require("./prescription-img.webp"),
  medication: require("./medication-img.webp"),
  pharmacy: require("./pharmacy-img.webp"),
  features: require("./features.webp"),
  network: require("./network.webp"),
  smartbg: require("./smart-hands-bg.webp"),
  phoneImg: require("./phon-img.webp"),
  ctaWomen: require("./CTA-Woman.webp"),
  bannerImg: require("./medicine-pharmaceutics.webp"),
  googlePlay: require("./googleplay.webp"),
  appStore: require("./appstore.webp"),
  doctorWomen: require("./doctor-women.webp"),
  scriptioHealth: require("./scriptio-health-care.webp"),

  emptyCart: require("./svg.webp"),
  bgImg: require("./Rectangle 2026.webp"),
  preImg: require("./P1-removebg.webp"),
  medImg: require("./p2-removebg.webp"),
  uploadPre: require("./Rectangle 2046.webp"),
  requestMed: require("./Rectangle 2062.webp"),
  pharmacies: require("./Rectangle 2050.webp"),
  myOrders: require("./image-removebg-preview_(6)-LvskMD_O8-transformed.webp"),
  blog: require("./Rectangle 2070.webp"),
  pdfIcon: require("./PDFIcon.webp"),
  wordIcon: require("./WordLogo.webp"),
  heroImage: require("./Hero Section.webp"),
  appMockImg1: require("./App Mock 1.webp"),
  appMockImg2: require("./newsletter-1 1.webp"),
  heroo3: require("./Hero Section (1).webp"),
  contactus:require("./contactus1.webp"),

};
export default Images;

export const Loader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <path
        d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
        fill="#1890FF"
        stroke="none"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="1s"
          repeatCount="indefinite"
          keyTimes="0;1"
          values="0 50 51;360 50 51"
        />
      </path>
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.60938 0.328125L9.48438 2.12921L8.055 3.50283L6.18 1.70175L7.60938 0.328125ZM0.109375 7.52524V9.32632H1.98438L7.17125 4.35114L5.29625 2.55006L0.109375 7.52524ZM0.109375 11.1274H10.1094V12.3281H0.109375V11.1274Z"
        fill="#53B1BF"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7604 8.82496C14.7471 7.73962 15.3391 6.62962 15.3391 5.98829C15.3391 4.53296 12.0337 0.265625 7.93906 0.265625C3.8444 0.265625 0.539062 4.53296 0.539062 5.98829C0.539062 7.44362 3.8444 11.711 7.93906 11.711C9.07373 11.711 10.1591 11.3903 11.1211 10.8723L13.7604 12.599V8.82496Z"
        fill="#27DEBF"
      />
      <path
        d="M7.93828 10.1305C9.98173 10.1305 11.6383 8.47392 11.6383 6.43047C11.6383 4.38702 9.98173 2.73047 7.93828 2.73047C5.89483 2.73047 4.23828 4.38702 4.23828 6.43047C4.23828 8.47392 5.89483 10.1305 7.93828 10.1305Z"
        fill="white"
      />
      <path
        d="M7.9407 4.22266C7.69404 4.22266 7.47204 4.27199 7.25004 4.32132C7.52137 4.54332 7.69404 4.88866 7.69404 5.25866C7.69404 5.94932 7.15137 6.49199 6.4607 6.49199C6.18937 6.49199 5.9427 6.39332 5.7207 6.24532V6.41799C5.7207 7.65132 6.70737 8.63799 7.9407 8.63799C9.17404 8.63799 10.1607 7.65132 10.1607 6.41799C10.1607 5.18466 9.17404 4.22266 7.9407 4.22266Z"
        fill="#27DEBF"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00028 0.828125C5.51343 0.828125 6.00695 1.02534 6.37876 1.37899C6.75057 1.73263 6.97223 2.21565 6.99789 2.72813L7.00039 2.82812H9.50053C9.62797 2.82827 9.75056 2.87706 9.84323 2.96455C9.9359 3.05203 9.99167 3.1716 9.99914 3.29882C10.0066 3.42604 9.96522 3.55131 9.88342 3.64904C9.80162 3.74677 9.68559 3.80957 9.55903 3.82463L9.50053 3.82812H9.076L8.48597 11.1046C8.44791 11.5742 8.23448 12.0122 7.88815 12.3315C7.54183 12.6509 7.08797 12.8282 6.61687 12.8281H3.38369C2.91258 12.8282 2.45873 12.6509 2.1124 12.3315C1.76607 12.0122 1.55265 11.5742 1.51458 11.1046L0.924051 3.82812H0.500028C0.377554 3.82811 0.259346 3.78315 0.167823 3.70177C0.0763008 3.62039 0.0178296 3.50825 0.00350018 3.38663L0 3.32812C1.61562e-05 3.20566 0.0449805 3.08746 0.126365 2.99594C0.207749 2.90442 0.319892 2.84595 0.441524 2.83162L0.500028 2.82812H3.00017C3.00017 2.29769 3.21089 1.78898 3.58599 1.41391C3.96108 1.03884 4.46981 0.828125 5.00028 0.828125ZM3.87521 5.45312C3.78459 5.45313 3.69703 5.48595 3.62874 5.54551C3.56044 5.60507 3.51602 5.68735 3.50369 5.77712L3.50019 5.82812V9.82812L3.50369 9.87912C3.51604 9.96888 3.56047 10.0511 3.62877 10.1107C3.69707 10.1702 3.78461 10.203 3.87521 10.203C3.96582 10.203 4.05336 10.1702 4.12166 10.1107C4.18996 10.0511 4.23439 9.96888 4.24674 9.87912L4.25024 9.82812V5.82812L4.24674 5.77712C4.23441 5.68735 4.18999 5.60507 4.12169 5.54551C4.0534 5.48595 3.96584 5.45313 3.87521 5.45312ZM6.12534 5.45312C6.03472 5.45313 5.94716 5.48595 5.87886 5.54551C5.81056 5.60507 5.76614 5.68735 5.75382 5.77712L5.75032 5.82812V9.82812L5.75382 9.87912C5.76617 9.96888 5.8106 10.0511 5.87889 10.1107C5.94719 10.1702 6.03473 10.203 6.12534 10.203C6.21595 10.203 6.30349 10.1702 6.37178 10.1107C6.44008 10.0511 6.48451 9.96888 6.49686 9.87912L6.50036 9.82812V5.82812L6.49686 5.77712C6.48454 5.68735 6.44012 5.60507 6.37182 5.54551C6.30352 5.48595 6.21596 5.45313 6.12534 5.45312ZM5.00028 1.82812C4.74797 1.82805 4.50497 1.92333 4.31997 2.09487C4.13496 2.26642 4.02164 2.50155 4.00272 2.75312L4.00022 2.82812H6.00033L5.99783 2.75312C5.97891 2.50155 5.86559 2.26642 5.68059 2.09487C5.49559 1.92333 5.25258 1.82805 5.00028 1.82812Z"
        fill="#FF2121"
      />
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg
      width="38"
      height="32"
      viewBox="0 0 38 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.7772 5.45673H27.9531L26.5656 1.59025C26.4698 1.32567 26.2941 1.09698 26.0626 0.935405C25.8311 0.773829 25.5552 0.687252 25.2723 0.687501H12.1339C11.5558 0.687501 11.0376 1.04945 10.8449 1.59025L9.45312 5.45673H3.62905C1.73623 5.45673 0.203125 6.98118 0.203125 8.86333V28.2809C0.203125 30.163 1.73623 31.6875 3.62905 31.6875H33.7772C35.67 31.6875 37.2031 30.163 37.2031 28.2809V8.86333C37.2031 6.98118 35.67 5.45673 33.7772 5.45673ZM18.7031 24.8743C14.9175 24.8743 11.8513 21.8254 11.8513 18.0611C11.8513 14.2968 14.9175 11.2479 18.7031 11.2479C22.4888 11.2479 25.555 14.2968 25.555 18.0611C25.555 21.8254 22.4888 24.8743 18.7031 24.8743ZM14.592 18.0611C14.592 19.1453 15.0251 20.1851 15.7961 20.9517C16.5671 21.7183 17.6128 22.149 18.7031 22.149C19.7935 22.149 20.8391 21.7183 21.6101 20.9517C22.3811 20.1851 22.8142 19.1453 22.8142 18.0611C22.8142 16.9769 22.3811 15.9372 21.6101 15.1705C20.8391 14.4039 19.7935 13.9732 18.7031 13.9732C17.6128 13.9732 16.5671 14.4039 15.7961 15.1705C15.0251 15.9372 14.592 16.9769 14.592 18.0611Z"
        fill="black"
        fillOpacity="0.1"
      />
    </svg>
  );
};

export const SearchCloseIcon = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.720734 5.26864C0.714684 8.00774 2.93512 10.2363 5.66498 10.2653C8.4626 10.2956 10.7423 8.01984 10.7205 5.22629C10.6988 2.50292 8.49165 0.294938 5.77388 0.265902C2.98473 0.236865 0.711054 2.49808 0.720734 5.26864ZM6.73587 5.2638C6.7516 5.28074 6.76128 5.29163 6.77338 5.30251C7.01418 5.54327 7.25498 5.78404 7.49578 6.02601C7.80918 6.33936 8.12379 6.65271 8.43719 6.96727C8.79053 7.32297 8.70703 7.89644 8.27021 8.11784C7.97375 8.26786 7.64945 8.21221 7.40986 7.97266C6.86534 7.42822 6.32082 6.88379 5.7763 6.33815C5.75815 6.32 5.74847 6.29338 5.73395 6.26798C5.47742 6.52447 5.24146 6.76039 5.00429 6.99752C4.67153 7.33023 4.3424 7.66415 4.00722 7.99323C3.71318 8.28117 3.22795 8.26907 2.97384 7.97387C2.72336 7.68229 2.71731 7.24312 3.01135 6.95638C3.44092 6.53656 3.86201 6.10828 4.28674 5.68362C4.42468 5.54569 4.56384 5.40898 4.7042 5.26864C4.68847 5.2517 4.67879 5.24081 4.66669 5.22871C4.39443 4.9565 4.12217 4.68428 3.84991 4.41206C3.56676 4.12896 3.28119 3.84585 2.99925 3.56033C2.72457 3.28327 2.71247 2.8199 2.97142 2.55857C3.24852 2.27909 3.72044 2.23917 4.03263 2.55736C4.57231 3.10663 5.12046 3.64744 5.66498 4.19308C5.68313 4.21123 5.69281 4.23784 5.70733 4.26325C5.96386 4.00676 6.19982 3.77084 6.43699 3.53371C6.76975 3.201 7.09888 2.86708 7.43407 2.538C7.72811 2.25006 8.21333 2.26216 8.46744 2.55736C8.71792 2.84894 8.72397 3.28811 8.42993 3.57485C8.00037 3.99466 7.57927 4.42295 7.15454 4.84761C7.01539 4.98674 6.87623 5.12346 6.73587 5.2638Z"
        fill="#D6D7E3"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37331 16.7915C13.138 16.7915 16.19 13.7396 16.19 9.97487C16.19 6.21013 13.138 3.1582 9.37331 3.1582C5.60857 3.1582 2.55664 6.21013 2.55664 9.97487C2.55664 13.7396 5.60857 16.7915 9.37331 16.7915Z"
        stroke="#53B1BF"
        strokeWidth="1.70417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8941 18.4956L14.1875 14.7891"
        stroke="#53B1BF"
        strokeWidth="1.70417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IdCard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.883"
      height="21.687"
      viewBox="0 0 27.883 21.687"
    >
      <path
        id="Icon_awesome-id-card"
        dataName="Icon awesome-id-card"
        d="M25.56,2.25H2.324A2.324,2.324,0,0,0,0,4.574v.775H27.883V4.574A2.324,2.324,0,0,0,25.56,2.25ZM0,21.613a2.324,2.324,0,0,0,2.324,2.324H25.56a2.324,2.324,0,0,0,2.324-2.324V6.9H0ZM17.04,10.383A.388.388,0,0,1,17.427,10H24.4a.388.388,0,0,1,.387.387v.775a.388.388,0,0,1-.387.387H17.427a.388.388,0,0,1-.387-.387Zm0,3.1a.388.388,0,0,1,.387-.387H24.4a.388.388,0,0,1,.387.387v.775a.388.388,0,0,1-.387.387H17.427a.388.388,0,0,1-.387-.387Zm0,3.1a.388.388,0,0,1,.387-.387H24.4a.388.388,0,0,1,.387.387v.775a.388.388,0,0,1-.387.387H17.427a.388.388,0,0,1-.387-.387ZM8.52,10a3.1,3.1,0,1,1-3.1,3.1A3.1,3.1,0,0,1,8.52,10ZM3.248,19.88A3.1,3.1,0,0,1,6.2,17.741h.4a4.986,4.986,0,0,0,3.853,0h.4a3.1,3.1,0,0,1,2.948,2.14.762.762,0,0,1-.755.958H4A.764.764,0,0,1,3.248,19.88Z"
        transform="translate(0 -2.25)"
        fill="#53b1bf"
      />
    </svg>
  );
};

export const InsuranceCard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.883"
      height="21.687"
      viewBox="0 0 27.883 21.687"
    >
      <path
        id="Icon_awesome-address-card"
        dataName="Icon awesome-address-card"
        d="M25.56,2.25H2.324A2.324,2.324,0,0,0,0,4.574v17.04a2.324,2.324,0,0,0,2.324,2.324H25.56a2.324,2.324,0,0,0,2.324-2.324V4.574A2.324,2.324,0,0,0,25.56,2.25ZM8.52,6.9a3.1,3.1,0,1,1-3.1,3.1A3.1,3.1,0,0,1,8.52,6.9ZM13.942,18.36a1.015,1.015,0,0,1-1.084.929H4.182A1.015,1.015,0,0,1,3.1,18.36v-.929a3.048,3.048,0,0,1,3.253-2.788h.242a4.986,4.986,0,0,0,3.853,0h.242a3.048,3.048,0,0,1,3.253,2.788ZM24.785,15.8a.388.388,0,0,1-.387.387H17.427a.388.388,0,0,1-.387-.387V15.03a.388.388,0,0,1,.387-.387H24.4a.388.388,0,0,1,.387.387Zm0-3.1a.388.388,0,0,1-.387.387H17.427a.388.388,0,0,1-.387-.387v-.775a.388.388,0,0,1,.387-.387H24.4a.388.388,0,0,1,.387.387Zm0-3.1A.388.388,0,0,1,24.4,10H17.427a.388.388,0,0,1-.387-.387V8.834a.388.388,0,0,1,.387-.387H24.4a.388.388,0,0,1,.387.387Z"
        transform="translate(0 -2.25)"
        fill="#53b1bf"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="381.798"
      height="381.798"
      viewBox="0 0 381.798 381.798"
    >
      <defs>
        <linearGradient
          id="linear-gradient-1"
          x1="-0.165"
          y1="-0.155"
          x2="1.16"
          y2="1.163"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#53b1bf" />
          <stop offset="1" stopColor="#285d9a" />
        </linearGradient>
      </defs>
      <g id="bxs-dashboard" transform="translate(-6 -6)">
        <path
          id="Path_3"
          dataName="Path 3"
          d="M27.211,218.11H154.477A21.211,21.211,0,0,0,175.688,196.9V27.211A21.211,21.211,0,0,0,154.477,6H27.211A21.211,21.211,0,0,0,6,27.211V196.9A21.211,21.211,0,0,0,27.211,218.11ZM6,366.587A21.211,21.211,0,0,0,27.211,387.8H154.477a21.211,21.211,0,0,0,21.211-21.211V281.743a21.211,21.211,0,0,0-21.211-21.211H27.211A21.211,21.211,0,0,0,6,281.743Zm212.11,0A21.211,21.211,0,0,0,239.321,387.8H366.587A21.211,21.211,0,0,0,387.8,366.587V218.11A21.211,21.211,0,0,0,366.587,196.9H239.321A21.211,21.211,0,0,0,218.11,218.11Zm21.211-212.11H366.587A21.211,21.211,0,0,0,387.8,133.266V27.211A21.211,21.211,0,0,0,366.587,6H239.321A21.211,21.211,0,0,0,218.11,27.211V133.266A21.211,21.211,0,0,0,239.321,154.477Z"
          transform="translate(0 0)"
          fill="url(#linear-gradient-1)"
        />
      </g>
    </svg>
  );
};

export const CapsuleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="398.725"
      height="311.986"
      viewBox="0 0 398.725 311.986"
    >
      <defs>
        <linearGradient
          id="linear-gradient-2"
          x1="-0.22"
          y1="-0.293"
          x2="1.115"
          y2="1.328"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#53b1bf" />
          <stop offset="1" stopColor="#285d9a" />
        </linearGradient>
      </defs>
      <g
        id="Group_3"
        dataName="Group 3"
        transform="translate(-310.906 -248.849)"
      >
        <path
          id="Union_1"
          dataName="Union 1"
          d="M-1266.323,496.65a71.994,71.994,0,0,1-71.992-72V256.657a72,72,0,0,1,72-71.993,72.011,72.011,0,0,1,71.242,61.565,71.668,71.668,0,0,1,27.343-34.9,72,72,0,0,1,99.946,19.434l93.941,139.274a71.776,71.776,0,0,1,10.984,53.993,71.77,71.77,0,0,1-30.417,45.952,71.994,71.994,0,0,1-99.945-19.433l-93.942-139.274a72.257,72.257,0,0,1-7.159-13.481V424.659a71.779,71.779,0,0,1-21.087,50.9,71.767,71.767,0,0,1-50.906,21.086Z"
          transform="translate(1671.162 64.185)"
          fill="url(#linear-gradient-2)"
        />
        <g id="Group_4" dataName="Group 4">
          <g id="pill" transform="translate(219.028 404.843) rotate(-45)">
            <g id="Group_2" dataName="Group 2" transform="translate(0 0)">
              <path
                id="Path_2"
                dataName="Path 2"
                d="M224.713,105.929l-50.9,50.912L105.935,88.962l50.912-50.9a47.994,47.994,0,1,1,67.88,67.868Z"
                fill="#fff"
                fillRule="evenodd"
              />
            </g>
          </g>
          <g
            id="pill-2"
            dataName="pill"
            transform="translate(436.611 508.749) rotate(-79)"
          >
            <g id="Group_2-2" dataName="Group 2" transform="translate(0 0)">
              <path
                id="Path_2-2"
                dataName="Path 2"
                d="M224.713,105.929l-50.9,50.912L105.935,88.962l50.912-50.9a47.994,47.994,0,1,1,67.88,67.868Z"
                fill="#fff"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HeartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="457.563"
      height="400.369"
      viewBox="0 0 457.563 400.369"
    >
      <defs>
        <linearGradient
          id="linear-gradient-3"
          x1="-0.046"
          y1="-0.132"
          x2="1.048"
          y2="1.134"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4a9fb7" />
          <stop offset="1" stopColor="#306ca1" />
        </linearGradient>
      </defs>
      <g id="Group_1" dataName="Group 1" transform="translate(-48.001 -73.25)">
        <path
          id="Subtraction_1"
          dataName="Subtraction 1"
          d="M228.743,400.369a27.785,27.785,0,0,1-10.775-2.162,28.363,28.363,0,0,1-9.467-6.485L35.578,213.169A125.7,125.7,0,0,1,7.781,168.7a129,129,0,0,1-6.337-24.928A130.17,130.17,0,0,1,3.823,93.1a127.8,127.8,0,0,1,8.6-24.054,125.64,125.64,0,0,1,32-41.675A113.664,113.664,0,0,1,80.063,6.73,116.641,116.641,0,0,1,119.374,0a123.706,123.706,0,0,1,24.9,2.554A127.788,127.788,0,0,1,168.429,10.1a130.1,130.1,0,0,1,22.582,12.381A131.624,131.624,0,0,1,211.183,39.53l17.6,18.141,17.6-18.141a132.09,132.09,0,0,1,20.2-17.043,130.4,130.4,0,0,1,22.595-12.381,127.875,127.875,0,0,1,24.158-7.551A123.62,123.62,0,0,1,338.232,0a116.537,116.537,0,0,1,39.292,6.729,113.686,113.686,0,0,1,35.627,20.647,126.094,126.094,0,0,1,40.6,65.74,129.7,129.7,0,0,1-4,75.591,125.7,125.7,0,0,1-27.846,44.462l-79.59,82.181a53.232,53.232,0,0,0-73.884,76.289l-19.451,20.084a28.363,28.363,0,0,1-9.467,6.485A27.785,27.785,0,0,1,228.743,400.369Z"
          transform="translate(48.001 73.25)"
          fill="url(#linear-gradient-3)"
        />
        <path
          id="Icon_ionic-ios-add-circle"
          dataName="Icon ionic-ios-add-circle"
          d="M46.98,3.375a43.6,43.6,0,1,0,43.6,43.6A43.6,43.6,0,0,0,46.98,3.375ZM65.952,50.334H50.334V65.952a3.354,3.354,0,0,1-6.708,0V50.334H28.007a3.354,3.354,0,1,1,0-6.708H43.625V28.007a3.354,3.354,0,1,1,6.708,0V43.625H65.952a3.354,3.354,0,0,1,0,6.708Z"
          transform="translate(308.517 361.799)"
          fill="url(#linear-gradient-3)"
        />
      </g>
    </svg>
  );
};

export const OrderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="394.559"
      height="407.659"
      viewBox="0 0 394.559 407.659"
    >
      <defs>
        <linearGradient
          id="linear-gradient-4"
          x1="-0.141"
          y1="-0.107"
          x2="1.145"
          y2="1.122"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#53b1bf" />
          <stop offset="1" stopColor="#285d9a" />
        </linearGradient>
      </defs>
      <g id="shopping" transform="translate(0 -0.041)">
        <path
          id="Path_1"
          dataName="Path 1"
          d="M369.9,203.894H24.66A23.444,23.444,0,0,1,7.128,196.53,24.8,24.8,0,0,1,0,178.618a25.482,25.482,0,0,1,7.128-18.112,23.147,23.147,0,0,1,17.532-7.563H46.237a55.5,55.5,0,0,0,19.844,18.709,54.857,54.857,0,0,0,52.788,0,55.5,55.5,0,0,0,19.844-18.709H255.847a55.5,55.5,0,0,0,19.844,18.709,54.857,54.857,0,0,0,52.788,0,55.5,55.5,0,0,0,19.844-18.709H369.9a23.147,23.147,0,0,1,17.532,7.563,25.482,25.482,0,0,1,7.128,18.112,24.8,24.8,0,0,1-7.128,17.913A23.444,23.444,0,0,1,369.9,203.894Zm-59.338-53.34a18.583,18.583,0,0,1-15.412,1.99,20.276,20.276,0,0,1-12.33-9.951L224.637,31.933a21.353,21.353,0,0,1-2.119-16.121,20.071,20.071,0,0,1,9.44-12.937A18.583,18.583,0,0,1,247.37.884a20.276,20.276,0,0,1,12.33,9.951L317.882,121.5A21.353,21.353,0,0,1,320,137.617,20.07,20.07,0,0,1,310.561,150.554ZM111.74,142.593a20.276,20.276,0,0,1-12.33,9.951A18.583,18.583,0,0,1,84,150.554a20.07,20.07,0,0,1-9.44-12.937A21.353,21.353,0,0,1,76.677,121.5l58.182-110.66A20.276,20.276,0,0,1,147.189.884,18.583,18.583,0,0,1,162.6,2.875a20.071,20.071,0,0,1,9.44,12.937,21.353,21.353,0,0,1-2.119,16.121Zm233.5,239.631q-3.082,15.922-11.367,20.7T308.635,407.7H87.466q-17.339,0-26.2-4.777t-11.945-20.7L24.66,229.37H369.9Z"
          transform="translate(0 0)"
          fill="url(#linear-gradient-4)"
        />
      </g>
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="410.8"
      height="469.6"
      viewBox="0 0 410.8 469.6"
    >
      <defs>
        <linearGradient
          id="linear-gradient-5"
          x1="-0.112"
          y1="-0.032"
          x2="1.1"
          y2="1.028"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#53b1bf" />
          <stop offset="1" stopColor="#285d9a" />
        </linearGradient>
      </defs>
      <path
        id="Icon_awesome-user"
        d="M250,250A117.4,117.4,0,1,0,132.6,132.6h0A117.385,117.385,0,0,0,250,250Zm82.2,29.3H316.9a159.354,159.354,0,0,1-133.7,0H167.9A123.3,123.3,0,0,0,44.6,402.6v38.2a44,44,0,0,0,44,44H411.4a44,44,0,0,0,44-44V402.6A123.4,123.4,0,0,0,332.2,279.3Z"
        transform="translate(-44.6 -15.2)"
        fill="url(#linear-gradient-5)"
      />
    </svg>
  );
};

export const StoreIcon = () => {
  return (
    <svg
      style={{ height: "24px" }}
      fill="#ffffff"
      height="800px"
      width="800px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="-51.1 -51.1 613.20 613.20"
      // xml:space="preserve"
      stroke="#ffffff"
      stroke-width="0.00511"
      transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"
    >
      <g
        id="SVGRepo_bgCarrier"
        stroke-width="0"
        transform="translate(255.5,255.5), scale(0)"
      >
        <rect
          x="-51.1"
          y="-51.1"
          width="613.20"
          height="613.20"
          rx="0"
          fill="#ffffff"
          strokewidth="0"
        />
      </g>

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="#53B1BF"
        stroke-width="21.1"
      >
        <g>
          <path d="M503.5,440H479V207.433c13.842-3.487,24-16.502,24-31.933v-104c0-8.547-6.953-15.5-15.5-15.5h-464 C14.953,56,8,62.953,8,71.5v104c0,15.432,10.158,28.446,24,31.933V440H7.5c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h496 c4.142,0,7.5-3.358,7.5-7.5S507.642,440,503.5,440z M488,71.5v104c0,9.383-6.999,17.384-15.602,17.834 c-4.595,0.235-8.939-1.36-12.254-4.505c-3.317-3.148-5.145-7.4-5.145-11.971V71h32.5C487.776,71,488,71.224,488,71.5z M71,71h33 v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M119,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5 s-16.5-7.402-16.5-16.5V71z M167,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M215,71h33v105.858 c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M263,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5 V71z M311,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M359,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5 s-16.5-7.402-16.5-16.5V71z M407,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M23,175.5v-104 c0-0.276,0.224-0.5,0.5-0.5H56v105.858c0,4.571-1.827,8.823-5.145,11.971c-3.314,3.146-7.663,4.743-12.254,4.505 C29.999,192.884,23,184.883,23,175.5z M47,207.462c5.266-1.279,10.128-3.907,14.181-7.753c0.822-0.78,1.599-1.603,2.326-2.462 c5.782,6.793,14.393,11.11,23.993,11.11c9.604,0,18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119 c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119 c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119 c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119c9.6,0,18.21-4.317,23.993-11.11 c0.728,0.859,1.504,1.682,2.326,2.462c4.054,3.847,8.914,6.482,14.181,7.761V440h-33V263.5c0-8.547-6.953-15.5-15.5-15.5h-96 c-8.547,0-15.5,6.953-15.5,15.5V440H47V207.462z M416,440h-97V263.5c0-0.276,0.224-0.5,0.5-0.5h96c0.276,0,0.5,0.224,0.5,0.5V440z" />
          <path d="M343.5,336c-4.142,0-7.5,3.358-7.5,7.5v16c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-16 C351,339.358,347.642,336,343.5,336z" />
          <path d="M262.5,248h-174c-4.687,0-8.5,3.813-8.5,8.5v142c0,4.687,3.813,8.5,8.5,8.5h174c4.687,0,8.5-3.813,8.5-8.5v-142 C271,251.813,267.187,248,262.5,248z M256,392H95V263h161V392z" />
        </g>
      </g>

      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M503.5,440H479V207.433c13.842-3.487,24-16.502,24-31.933v-104c0-8.547-6.953-15.5-15.5-15.5h-464 C14.953,56,8,62.953,8,71.5v104c0,15.432,10.158,28.446,24,31.933V440H7.5c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h496 c4.142,0,7.5-3.358,7.5-7.5S507.642,440,503.5,440z M488,71.5v104c0,9.383-6.999,17.384-15.602,17.834 c-4.595,0.235-8.939-1.36-12.254-4.505c-3.317-3.148-5.145-7.4-5.145-11.971V71h32.5C487.776,71,488,71.224,488,71.5z M71,71h33 v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M119,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5 s-16.5-7.402-16.5-16.5V71z M167,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M215,71h33v105.858 c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M263,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5 V71z M311,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M359,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5 s-16.5-7.402-16.5-16.5V71z M407,71h33v105.858c0,9.098-7.402,16.5-16.5,16.5s-16.5-7.402-16.5-16.5V71z M23,175.5v-104 c0-0.276,0.224-0.5,0.5-0.5H56v105.858c0,4.571-1.827,8.823-5.145,11.971c-3.314,3.146-7.663,4.743-12.254,4.505 C29.999,192.884,23,184.883,23,175.5z M47,207.462c5.266-1.279,10.128-3.907,14.181-7.753c0.822-0.78,1.599-1.603,2.326-2.462 c5.782,6.793,14.393,11.11,23.993,11.11c9.604,0,18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119 c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119 c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119 c5.782,6.799,14.396,11.119,24,11.119s18.218-4.32,24-11.119c5.782,6.799,14.396,11.119,24,11.119c9.6,0,18.21-4.317,23.993-11.11 c0.728,0.859,1.504,1.682,2.326,2.462c4.054,3.847,8.914,6.482,14.181,7.761V440h-33V263.5c0-8.547-6.953-15.5-15.5-15.5h-96 c-8.547,0-15.5,6.953-15.5,15.5V440H47V207.462z M416,440h-97V263.5c0-0.276,0.224-0.5,0.5-0.5h96c0.276,0,0.5,0.224,0.5,0.5V440z" />
          <path d="M343.5,336c-4.142,0-7.5,3.358-7.5,7.5v16c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-16 C351,339.358,347.642,336,343.5,336z" />
          <path d="M262.5,248h-174c-4.687,0-8.5,3.813-8.5,8.5v142c0,4.687,3.813,8.5,8.5,8.5h174c4.687,0,8.5-3.813,8.5-8.5v-142 C271,251.813,267.187,248,262.5,248z M256,392H95V263h161V392z" />
        </g>
      </g>
    </svg>
  );
};

export const CalenderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="21.461"
      height="21.948"
      viewBox="0 0 21.461 21.948"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#53b1bf" />
          <stop offset="1" stop-color="#285d9a" />
        </linearGradient>
      </defs>
      <g
        id="Group_8353"
        data-name="Group 8353"
        transform="translate(-115.986 -201)"
      >
        <path
          id="Path_15110"
          data-name="Path 15110"
          d="M388.956,201a.873.873,0,0,1,.6.949c-.013,1.327,0,2.654,0,3.982,0,.64-.27.907-.914.908-.385,0-.771,0-1.156,0a.728.728,0,0,1-.78-.758c-.01-1.441-.007-2.883,0-4.324a.784.784,0,0,1,.588-.755Z"
          transform="translate(-255.466 0)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15111"
          data-name="Path 15111"
          d="M177.313,201a.865.865,0,0,1,.6.943c-.014,1.334,0,2.669-.005,4,0,.615-.275.89-.886.892q-.546,0-1.092,0a.767.767,0,0,1-.874-.882q0-1.563,0-3.126c0-.293.012-.586,0-.878a.856.856,0,0,1,.587-.953Z"
          transform="translate(-55.741 0)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15112"
          data-name="Path 15112"
          d="M135.542,244.524a1.958,1.958,0,0,1,1.9,1.9c0,.064,0,.128,0,.193q0,7.639,0,15.278a2.006,2.006,0,0,1-2.1,2.122h-17.3a1.987,1.987,0,0,1-1.672-.8,2.065,2.065,0,0,1-.4-1.305c0-1.736,0-3.471,0-5.207q0-5.036,0-10.071a2.025,2.025,0,0,1,.772-1.706,1.951,1.951,0,0,1,1.134-.41v.233q0,1.146,0,2.293a2.185,2.185,0,0,0,2.268,2.289c.4,0,.8,0,1.2,0a2.195,2.195,0,0,0,2.268-2.292c0-.835,0-1.669,0-2.52h6.177v.229c0,.771,0,1.543,0,2.314a2.188,2.188,0,0,0,2.206,2.267c.443.012.886.011,1.329,0a2.177,2.177,0,0,0,2.2-2.247c0-.771,0-1.543,0-2.314Zm-8.825,7.662h-7.2c-.7,0-1.024.318-1.024,1.017q0,3.847,0,7.693c0,.7.321,1.023,1.019,1.023h14.382a.882.882,0,0,0,1.012-1.007q0-3.857,0-7.715a.882.882,0,0,0-1.006-1.012Z"
          transform="translate(0 -41.072)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15113"
          data-name="Path 15113"
          d="M283.6,407.261c.271,0,.543,0,.814,0a.5.5,0,0,1,.546.529q.016.835,0,1.671a.484.484,0,0,1-.5.525q-.856.028-1.713,0a.5.5,0,0,1-.516-.559q-.01-.8,0-1.606a.511.511,0,0,1,.56-.561C283.055,407.257,283.327,407.261,283.6,407.261Z"
          transform="translate(-156.876 -194.648)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15114"
          data-name="Path 15114"
          d="M283.577,487.043c-.264,0-.528,0-.792,0a.515.515,0,0,1-.561-.562q-.01-.8,0-1.606a.516.516,0,0,1,.558-.565c.535-.009,1.071-.008,1.606,0a.52.52,0,0,1,.572.574q.008.792,0,1.585a.522.522,0,0,1-.591.575C284.105,487.046,283.841,487.043,283.577,487.043Z"
          transform="translate(-156.875 -267.354)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15115"
          data-name="Path 15115"
          d="M206.524,407.266c.264,0,.528,0,.792,0a.5.5,0,0,1,.562.533q.02.835,0,1.67a.485.485,0,0,1-.526.525q-.835.022-1.67,0a.5.5,0,0,1-.529-.565q-.007-.8,0-1.606a.5.5,0,0,1,.558-.557C205.981,407.262,206.253,407.266,206.524,407.266Z"
          transform="translate(-84.143 -194.653)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15116"
          data-name="Path 15116"
          d="M362.143,408.634c0,.264,0,.528,0,.792a.492.492,0,0,1-.514.557c-.563.017-1.128.016-1.691,0a.484.484,0,0,1-.52-.53c-.013-.556-.014-1.114,0-1.67a.5.5,0,0,1,.567-.527q.792-.006,1.585,0c.387,0,.57.191.574.585C362.146,408.106,362.143,408.37,362.143,408.634Z"
          transform="translate(-229.717 -194.643)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15117"
          data-name="Path 15117"
          d="M206.488,487.027c-.264,0-.528.005-.792,0a.5.5,0,0,1-.547-.548q-.009-.814,0-1.627a.5.5,0,0,1,.539-.557q.824-.017,1.649,0a.49.49,0,0,1,.535.516q.023.845,0,1.691a.5.5,0,0,1-.55.524C207.045,487.032,206.766,487.027,206.488,487.027Z"
          transform="translate(-84.139 -267.338)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_15118"
          data-name="Path 15118"
          d="M362.18,485.651c0,.278.005.557,0,.835a.492.492,0,0,1-.519.531q-.846.015-1.692,0a.473.473,0,0,1-.509-.494q-.025-.866,0-1.734a.481.481,0,0,1,.527-.5c.557-.012,1.114-.013,1.67,0a.5.5,0,0,1,.524.55C362.185,485.108,362.181,485.379,362.18,485.651Z"
          transform="translate(-229.755 -267.331)"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  );
};
export const Search = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 34 36"
      fill="none"
    >
      <path
        d="M15.0371 3.91212C13.4715 3.91212 12.011 4.20272 10.6557 4.7839C9.27698 5.36509 8.07938 6.16131 7.06289 7.17257C6.04639 8.18384 5.24605 9.37527 4.66186 10.7469C4.07766 12.0952 3.78557 13.5482 3.78557 15.1058C3.78557 16.6401 4.07766 18.0931 4.66186 19.4646C5.24605 20.813 6.04639 21.9986 7.06289 23.0215C8.07938 24.0444 9.27698 24.8464 10.6557 25.4276C12.011 26.0088 13.4715 26.2994 15.0371 26.2994C16.5794 26.2994 18.0399 26.0088 19.4186 25.4276C20.7739 24.8464 21.9656 24.0444 22.9938 23.0215C24.022 21.9986 24.8282 20.813 25.4124 19.4646C25.9966 18.0931 26.2887 16.6401 26.2887 15.1058C26.2887 13.5482 25.9966 12.0952 25.4124 10.7469C24.8282 9.37527 24.022 8.18384 22.9938 7.17257C21.9656 6.16131 20.7739 5.36509 19.4186 4.7839C18.0399 4.20272 16.5794 3.91212 15.0371 3.91212ZM0 15.1058C0 13.0367 0.397251 11.0956 1.19175 9.28228C1.96289 7.46898 3.03196 5.88234 4.39897 4.52237C5.76598 3.1624 7.36083 2.09883 9.18351 1.33166C11.0062 0.541248 12.9574 0.146042 15.0371 0.146042C17.1168 0.146042 19.068 0.541248 20.8907 1.33166C22.7134 2.09883 24.3024 3.1624 25.6577 4.52237C27.0131 5.88234 28.088 7.46898 28.8825 9.28228C29.677 11.0956 30.0742 13.0367 30.0742 15.1058C30.0742 16.1054 29.9808 17.0818 29.7938 18.0349C29.5835 18.9881 29.2973 19.9005 28.9351 20.7723C28.5729 21.6441 28.1347 22.4752 27.6206 23.2656C27.1065 24.056 26.5223 24.7883 25.868 25.4625L32.5629 32.088C32.9368 32.46 33.1237 32.9075 33.1237 33.4305C33.1237 33.9536 32.9368 34.3895 32.5629 34.7382C32.189 35.1102 31.745 35.2961 31.2309 35.2961C30.7168 35.2961 30.2729 35.1218 29.899 34.7731L22.9237 27.8337C21.7787 28.5311 20.5402 29.0775 19.2083 29.4727C17.8763 29.8679 16.4859 30.0655 15.0371 30.0655C12.9574 30.0655 11.0062 29.6703 9.18351 28.8799C7.36083 28.0894 5.76598 27.0201 4.39897 25.6717C3.03196 24.3234 1.96289 22.7425 1.19175 20.9292C0.397251 19.1159 0 17.1748 0 15.1058ZM17.3856 6.45772C17.666 6.01602 18.0574 5.73705 18.5598 5.62081C19.0622 5.50457 19.5354 5.58594 19.9794 5.86491C21.1244 6.56233 22.1351 7.41086 23.0113 8.4105C23.8876 9.41014 24.5945 10.526 25.132 11.7581C25.3423 12.2231 25.354 12.6996 25.167 13.1878C24.9801 13.676 24.6412 14.0248 24.1505 14.234C23.6832 14.4432 23.2041 14.449 22.7134 14.2514C22.2227 14.0538 21.8722 13.7225 21.6619 13.2576C21.288 12.3742 20.7856 11.578 20.1546 10.8689C19.5237 10.1599 18.811 9.56125 18.0165 9.07305C17.5725 8.79408 17.2863 8.39888 17.1577 7.88743C17.0292 7.37599 17.1052 6.89942 17.3856 6.45772Z"
        fill="#3C86AD"
      />
    </svg>
  );
};

export const PrescriptionIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14.875 17"
    >
      <path
        id="Icon_awesome-file-medical-alt"
        data-name="Icon awesome-file-medical-alt"
        d="M9.563,4.515V0H2.922a.793.793,0,0,0-.793.793V8.5H.265A.266.266,0,0,0,0,8.765v.528a.266.266,0,0,0,.265.265H4.944a.271.271,0,0,1,.239.146l.661,1.321L7.729,7.253a.265.265,0,0,1,.475,0l1.153,2.31h2.331a.532.532,0,0,1,0,1.062H8.7L7.968,9.157,6.083,12.932a.265.265,0,0,1-.475,0L4.453,10.625H2.125v5.582A.793.793,0,0,0,2.918,17H14.075a.793.793,0,0,0,.793-.793V5.312H10.36A.8.8,0,0,1,9.563,4.515Zm5.08-1.029L11.392.232A.793.793,0,0,0,10.828,0h-.2V4.25h4.25v-.2a.793.793,0,0,0-.232-.561Z"
        fill="#53b1bf"
      />
    </svg>
  );
};

export const AdditionalDocsIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12.951 17"
    >
      <g
        id="Group_8380"
        data-name="Group 8380"
        transform="translate(874.267 -332.261)"
      >
        <path
          id="Path_15128"
          data-name="Path 15128"
          d="M-872.673,332.261h6.176q0,1.867,0,3.735a1.167,1.167,0,0,0,1.245,1.246h3.935v.121q0,5.029,0,10.058a1.818,1.818,0,0,1-1.88,1.839q-4.589,0-9.179,0a2.088,2.088,0,0,1-.476-.05,1.817,1.817,0,0,1-1.412-1.83q0-4.739,0-9.478c0-1.261,0-2.523,0-3.784a1.729,1.729,0,0,1,.792-1.522A4.5,4.5,0,0,1-872.673,332.261Zm4.781,6.641q-1.816,0-3.633,0a.5.5,0,0,0-.515.443.5.5,0,0,0,.392.539,1.006,1.006,0,0,0,.214.013h7.166a.489.489,0,0,0,.486-.309.5.5,0,0,0-.494-.686Q-866.084,338.9-867.892,338.9Zm0,3.652h.481q1.559,0,3.118,0a.5.5,0,0,0,.507-.3.5.5,0,0,0-.5-.693h-7.232a.488.488,0,0,0-.485.31.5.5,0,0,0,.5.685Q-869.7,342.556-867.89,342.554Zm-2.438,1.66c-.387,0-.775,0-1.162,0a.5.5,0,0,0-.551.493.5.5,0,0,0,.542.5q1.162,0,2.324,0a.508.508,0,0,0,.545-.5.51.51,0,0,0-.552-.494C-869.564,344.213-869.946,344.214-870.328,344.214Z"
          transform="translate(0 0)"
          fill="#53b1bf"
        />
        <path
          id="Path_15129"
          data-name="Path 15129"
          d="M-672.649,340.424h-3.718c-.232,0-.272-.04-.272-.267q0-1.667,0-3.335c0-.047,0-.095.008-.188a5.041,5.041,0,0,1,.4.307q1.6,1.507,3.193,3.022A5.7,5.7,0,0,1-672.649,340.424Z"
          transform="translate(-188.862 -4.179)"
          fill="#53b1bf"
        />
      </g>
    </svg>
  );
};
export const Cart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
    >
      <path
        d="M13.4191 4.78736C13.4072 4.58593 13.3332 4.42004 13.197 4.2897C13.0608 4.15936 12.898 4.0942 12.7085 4.0942H10.6479C10.6005 3.16998 10.2423 2.38498 9.57322 1.73922C8.90412 1.09345 8.10771 0.770563 7.184 0.770563C6.26029 0.770563 5.46389 1.09345 4.79479 1.73922C4.12569 2.38498 3.76746 3.16998 3.72009 4.0942H1.67726C1.47594 4.0942 1.30719 4.16529 1.171 4.30748C1.03481 4.44966 0.966717 4.61555 0.966717 4.80513L0.469335 17.2999C0.457492 17.5131 0.487098 17.7175 0.558153 17.913C0.629208 18.1085 0.741711 18.2833 0.895663 18.4374C1.03777 18.5914 1.20357 18.7099 1.39305 18.7928C1.58252 18.8758 1.78385 18.9172 1.99701 18.9172H12.371C12.5842 18.9172 12.7825 18.8758 12.9661 18.7928C13.1496 18.7099 13.3184 18.5914 13.4723 18.4374C13.6145 18.2833 13.721 18.1115 13.7921 17.9219C13.8631 17.7323 13.8987 17.5309 13.8987 17.3176L13.4191 4.78736ZM7.184 1.65924C7.87086 1.65924 8.46299 1.89621 8.96037 2.37017C9.45775 2.84413 9.72421 3.41881 9.75974 4.0942L4.60827 4.07642C4.6438 3.41288 4.91025 2.84413 5.40764 2.37017C5.90502 1.89621 6.49714 1.65924 7.184 1.65924ZM3.72009 5.00064V6.49361C3.72009 6.6121 3.7645 6.71578 3.85331 6.80464C3.94213 6.89351 4.05168 6.93794 4.18194 6.93794C4.31221 6.93794 4.42175 6.89351 4.51057 6.80464C4.59939 6.71578 4.6438 6.6121 4.6438 6.49361V5.00064H9.7775V6.49361C9.7775 6.6121 9.82191 6.71578 9.91073 6.80464C9.99955 6.89351 10.1091 6.93794 10.2394 6.93794C10.3696 6.93794 10.4792 6.89351 10.568 6.80464C10.6568 6.71578 10.7012 6.6121 10.7012 6.49361V5.00064H12.5664L13.046 17.2999C13.0342 17.3946 13.0105 17.4835 12.975 17.5665C12.9394 17.6494 12.8861 17.7205 12.8151 17.7797C12.7559 17.8508 12.6878 17.9042 12.6108 17.9397C12.5338 17.9752 12.4539 17.993 12.371 17.993H1.99701C1.90227 17.993 1.81641 17.9752 1.73944 17.9397C1.66246 17.9042 1.59437 17.8508 1.53515 17.7797C1.4641 17.7205 1.41673 17.6524 1.39305 17.5753C1.36936 17.4983 1.35752 17.4124 1.35752 17.3176L1.83714 5.00064H3.72009Z"
        fill="#222222"
      />
    </svg>
  );
};
export const AppMock1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="38"
      viewBox="0 0 34 38"
      fill="none"
    >
      <path
        d="M23.25 33.4167L25.1667 31.5001L22.5 28.8334L20.5833 30.7501C20.1944 31.139 20 31.5834 20 32.0834C20 32.5834 20.1944 33.0279 20.5833 33.4167C20.9722 33.8056 21.4167 34.0001 21.9167 34.0001C22.4167 34.0001 22.8611 33.8056 23.25 33.4167ZM27.5 29.1667L29.4167 27.2501C29.8056 26.8612 30 26.4167 30 25.9167C30 25.4167 29.8056 24.9723 29.4167 24.5834C29.0278 24.1945 28.5833 24.0001 28.0833 24.0001C27.5833 24.0001 27.1389 24.1945 26.75 24.5834L24.8333 26.5001L27.5 29.1667ZM25.625 35.7917C24.5972 36.8195 23.3611 37.3334 21.9167 37.3334C20.4722 37.3334 19.2361 36.8195 18.2083 35.7917C17.1806 34.764 16.6667 33.5279 16.6667 32.0834C16.6667 30.639 17.1806 29.4029 18.2083 28.3751L24.375 22.2084C25.4028 21.1806 26.6389 20.6667 28.0833 20.6667C29.5278 20.6667 30.7639 21.1806 31.7917 22.2084C32.8194 23.2362 33.3333 24.4723 33.3333 25.9167C33.3333 27.3612 32.8194 28.5973 31.7917 29.6251L25.625 35.7917ZM3.33333 34.0001C2.41667 34.0001 1.63194 33.6737 0.979167 33.0209C0.326389 32.3681 0 31.5834 0 30.6667V7.33342C0 6.41675 0.326389 5.63203 0.979167 4.97925C1.63194 4.32647 2.41667 4.00008 3.33333 4.00008H10.3333C10.6944 3.00008 11.2986 2.19453 12.1458 1.58341C12.9931 0.972304 13.9444 0.666748 15 0.666748C16.0556 0.666748 17.0069 0.972304 17.8542 1.58341C18.7014 2.19453 19.3056 3.00008 19.6667 4.00008H26.6667C27.5833 4.00008 28.3681 4.32647 29.0208 4.97925C29.6736 5.63203 30 6.41675 30 7.33342V17.5417C29.4444 17.4029 28.8889 17.3334 28.3333 17.3334C27.7778 17.3334 27.2222 17.3751 26.6667 17.4584V7.33342H3.33333V30.6667H13.4583C13.375 31.2223 13.3333 31.7779 13.3333 32.3334C13.3333 32.889 13.4028 33.4445 13.5417 34.0001H3.33333ZM15 6.08342C15.3611 6.08342 15.6597 5.96536 15.8958 5.72925C16.1319 5.49314 16.25 5.19453 16.25 4.83342C16.25 4.4723 16.1319 4.17369 15.8958 3.93758C15.6597 3.70147 15.3611 3.58341 15 3.58341C14.6389 3.58341 14.3403 3.70147 14.1042 3.93758C13.8681 4.17369 13.75 4.4723 13.75 4.83342C13.75 5.19453 13.8681 5.49314 14.1042 5.72925C14.3403 5.96536 14.6389 6.08342 15 6.08342ZM6.66667 14.0001V10.6667H23.3333V14.0001H6.66667ZM6.66667 20.6667V17.3334H23.3333V18.7501C23.1111 18.889 22.8958 19.0487 22.6875 19.2292C22.4792 19.4098 22.2639 19.6112 22.0417 19.8334L21.2083 20.6667H6.66667ZM6.66667 27.3334V24.0001H17.875L15.8333 26.0417C15.6111 26.264 15.4097 26.4792 15.2292 26.6876C15.0486 26.8959 14.8889 27.1112 14.75 27.3334H6.66667Z"
        fill="#3C86AD"
      />
    </svg>
  );
};
export const AppMock2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="34"
      viewBox="0 0 30 34"
      fill="none"
    >
      <path
        d="M0 34.0001V30.6667L3.33333 20.6667L0 10.6667V7.33341H21.1667L23.5833 0.666748L27.5 2.08341L25.5833 7.33341H30V10.6667L26.6667 20.6667L30 30.6667V34.0001H0ZM13.3333 27.3334H16.6667V22.3334H21.6667V19.0001H16.6667V14.0001H13.3333V19.0001H8.33333V22.3334H13.3333V27.3334ZM3.5 30.6667H26.5L23.1667 20.6667L26.5 10.6667H3.5L6.83333 20.6667L3.5 30.6667Z"
        fill="#3C86AD"
      />
    </svg>
  );
};
export const AppMock3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="36"
      viewBox="0 0 28 36"
      fill="none"
    >
      <path
        d="M12.3327 30.6667H15.666V25.6667H20.666V22.3334H15.666V17.3334H12.3327V22.3334H7.33268V25.6667H12.3327V30.6667ZM3.99935 35.6667C3.08268 35.6667 2.29796 35.3404 1.64518 34.6876C0.992404 34.0348 0.666016 33.2501 0.666016 32.3334V15.6667C0.666016 14.7501 0.992404 13.9654 1.64518 13.3126C2.29796 12.6598 3.08268 12.3334 3.99935 12.3334H5.66602V9.00008C5.66602 6.69453 6.47852 4.72925 8.10352 3.10425C9.72852 1.47925 11.6938 0.666748 13.9993 0.666748C16.3049 0.666748 18.2702 1.47925 19.8952 3.10425C21.5202 4.72925 22.3327 6.69453 22.3327 9.00008V12.3334H23.9993C24.916 12.3334 25.7007 12.6598 26.3535 13.3126C27.0063 13.9654 27.3327 14.7501 27.3327 15.6667V32.3334C27.3327 33.2501 27.0063 34.0348 26.3535 34.6876C25.7007 35.3404 24.916 35.6667 23.9993 35.6667H3.99935ZM3.99935 32.3334H23.9993V15.6667H3.99935V32.3334ZM8.99935 12.3334H18.9993V9.00008C18.9993 7.61119 18.5132 6.43064 17.541 5.45841C16.5688 4.48619 15.3882 4.00008 13.9993 4.00008C12.6105 4.00008 11.4299 4.48619 10.4577 5.45841C9.48546 6.43064 8.99935 7.61119 8.99935 9.00008V12.3334Z"
        fill="#3C86AD"
      />
    </svg>
  );
};
export const AppMock4 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
    >
      <path
        d="M9.50065 24.1667H14.5007V20H18.6673V15H14.5007V10.8333H9.50065V15H5.33398V20H9.50065V24.1667ZM3.66732 30C2.75065 30 1.96593 29.6736 1.31315 29.0208C0.660373 28.3681 0.333984 27.5833 0.333984 26.6667V8.33333C0.333984 7.41667 0.660373 6.63194 1.31315 5.97917C1.96593 5.32639 2.75065 5 3.66732 5H20.334C21.2507 5 22.0354 5.32639 22.6882 5.97917C23.3409 6.63194 23.6673 7.41667 23.6673 8.33333V26.6667C23.6673 27.5833 23.3409 28.3681 22.6882 29.0208C22.0354 29.6736 21.2507 30 20.334 30H3.66732ZM3.66732 26.6667H20.334V8.33333H3.66732V26.6667ZM2.00065 3.33333V0H22.0007V3.33333H2.00065Z"
        fill="#3C86AD"
      />
    </svg>
  );
};
